/**
 * Handler that always returns `false`.
 */
export const PRIZM_ALWAYS_FALSE_HANDLER = (): false => false;
